<template>
  <div class="modal modal-filter-details fade" id="add-tag-talent" role="dialog" aria-labelledby="location-label" aria-hidden="true">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <h4 class="modal-title">
            Add {{ $starLabelPlural | sentenceCase }} to {{ tag.name }}
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </h4>
        </div>
        <div class="modal-body">
          <div>
            <div class="row">
              <div class="col-lg-12">
                <div class="form-group">
                  <p class="sub-head">Filter Talent &ndash; <span>{{ pagination.total }}</span> Found</p>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-sm-12">
                <div class="input-group">
                  <input
                    type="text"
                    class="form-control"
                    :placeholder="$options.filters.sentenceCase($starLabel) + ' Name...'"
                    v-model="keywords"
                    v-on:keyup.enter="getTalent">
                  <span class="input-group-btn">
                    <ladda-button
                      ref="search"
                      class="btn btn-dark"
                      type="submit"
                      :click="getTalent">
                      Search
                    </ladda-button>
                  </span>
                </div>
              </div>
            </div>
            <div class="row m-t-xs m-b-xs">
              <div class="col-lg-12">
                <a class="cursor-pointer pull-right" @click="handleClearFilter()">
                  <span>Clear Filter</span>
                </a>
              </div>
            </div>
            <br/>
            <div class="row row-results">
              <div v-for="t in talent"
                   :key="t.id"
                   class="col-xs-6 col-sm-4">
                <system-tag-management-talent-list-item
                  :talent="t"
                  @removeTagTalent="removeTagTalent"
                  @addTagTalent="addTagTalent"
                />
              </div>
            </div>
            <div class="text-center" v-if="talent.length === 0">
              <h5>Couldn't find any {{ $starLabelPlural }}. Please check search credentials and try again.</h5>
            </div>
            <lazy-loading
              scroll-target="#add-tag-talent .modal-body"
              class="text-center m-b-md"
              :loading="fetching"
              :reached-bottom="getNextTalent"
              ref="lazyLoading">
              <div slot="loading" class="pickstar-loading"></div>
              <span slot="finished"></span>
            </lazy-loading>
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-lg btn-primary pull-right" data-dismiss="modal"><i class="fa fa-check"></i> Done</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { handleServerErrors } from 'mixins'
import { http } from 'utils'
import LazyLoading from 'codium-lazy-loading'
import SystemTagManagementTalentListItem from './SystemTagManagementTalentListItem'

export default {
  mixins: [handleServerErrors],

  data () {
    return {
      keywords: '',
      fetching: false,
      talent: [],
      pagination: {}
    }
  },

  props: {
    tag: {
      required: true
    }
  },

  components: {
    LazyLoading,
    SystemTagManagementTalentListItem
  },

  created () {
    this.getTalent()
  },

  methods: {
    getTalent () {
      this.fetching = true
      return http.get('talent', { params: { page: 1, tag_id: this.$route.params.id, keywords: this.keywords, tag_type: this.$route.params.tagType } })
        .then(response => {
          this.talent = response.data.data
          this.pagination = response.data.meta
          this.fetching = false
          return response
        })
    },

    getNextTalent () {
      this.fetching = true
      if (this.pagination && this.pagination.current_page < this.pagination.last_page) {
        return http.get(`talent`, { params: { page: this.pagination.current_page + 1, tag_id: this.$route.params.id, keywords: this.keywords } })
          .then((response) => {
            this.talent.push(...response.data.data)
            this.pagination = response.data.meta
            this.fetching = false
            return response
          })
      }
      return Promise.resolve()
    },

    handleClearFilter () {
      if (this.keywords !== '') {
        this.fetchingTalent = true
        this.keywords = ''
        return this.getTalent().then(() => {
          this.fetchingTalent = false
          this.$refs.lazyLoading.$emit('reset')
        })
          .catch(this.handleServerErrorsCallback)
      }
      return Promise.resolve()
    },

    removeTagTalent (talent) {
      this.$emit('removeTagTalent', talent)
    },

    addTagTalent (talent) {
      this.$emit('addTagTalent', talent)
    }
  }
}
</script>
